﻿import {KeysetQuery, KeysetQueryResult} from "@2d-front-monorepo/core";
import {ParkingType} from "../../nominalTypes/ParkingType";
import {ReservationId} from "../../nominalTypes/ReservationId";
import {CreateReservationArguments} from "../../types/arguments/CreateReservationArguments";
import {AvailablePaymentMethods} from "../../types/AvailablePaymentMethods";
import {CreateReservationResult} from "../../types/CreateReservationResult";
import {ListReservationsResult} from "../../types/ListReservationsResult";
import {PaymentHistoryEntry} from "../../types/PaymentHistoryEntry";
import {ReservationCategoryData} from "../../types/ReservationCategoryData";
import {ReservationResult} from "../../types/ReservationResult";
import IPermitsReservations from "../IPermitsReservations";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsReservations implements IPermitsReservations {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	archived(query?: KeysetQuery<ReservationId> | undefined, signal?: AbortSignal | undefined): Promise<KeysetQueryResult<ReservationResult>> {
		return this._client.jsonFetch("reservations/archived", "GET", query, {
			signal: signal
		});
	}

	approve(reservationId: ReservationId, data: AvailablePaymentMethods, signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch(`reservations/${reservationId}/approve`, "PUT", data, {
			signal: signal
		});
	}

	list(signal?: AbortSignal | undefined): Promise<ListReservationsResult> {
		return this._client.jsonFetch("reservations", "GET", null, {
			signal: signal
		});
	}

	getParkingTypeData(parkingType: ParkingType, signal?: AbortSignal | undefined): Promise<ReservationCategoryData> {
		return this._client.jsonFetch(`reservations/parking-type/${parkingType}`, "GET", null, {
			signal: signal
		});
	}

	create(data: CreateReservationArguments, signal?: AbortSignal | undefined): Promise<CreateReservationResult> {
		return this._client.jsonFetch("reservations", "POST", data, {
			signal: signal
		});
	}

	cancel(reservationId: ReservationId, signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch(`reservations/${reservationId}/cancel`, "PUT", null, {
			signal: signal
		});
	}

	public listPayments(query?: KeysetQuery<number> | undefined, signal?: AbortSignal | undefined): Promise<KeysetQueryResult<PaymentHistoryEntry>> {
		return this._client.jsonFetch("reservations/payments", "GET", query, {
			signal: signal
		});
	}
}
